import { resolveTenantSlug } from './resolve'

let _slug: string | null | undefined = undefined

export function getCurrentTenantSlug(): string | null {
  if (_slug === undefined) {
    _slug = typeof window !== 'undefined'
      ? resolveTenantSlug(window.location.host)
      : null
  }
  return _slug
}

export function resetTenantSlugForTests() {
  _slug = undefined
}
